import {
  getBodyClassNameApi,
  getPageApi,
  getMenuApi,
  CmsCriteria,
  CmsPageVm,
  CmsMenuVm,
  CmsBodyClassVm
} from "@/services/cms";
import actions from "./actions";
import { ApiCallParams } from "@/services/baseService";

export default {
  actions: {
    async [actions.FETCH_CMS_BODY_CLASS_NAME](ctx?: any, subdomain?: string) {
      if (subdomain !== undefined) {
        const response = await getBodyClassNameApi(subdomain);
        if (response !== undefined) {
          ctx.commit("updateCmsBodyClassMutation", response);
          if (document.body.className !== response.name) {
            document.body.className = response.name;
          }
        }
      }
    },

    async [actions.FETCH_CMS_PAGE](
      ctx?: any,
      params?: ApiCallParams<CmsCriteria>
    ) {
      if (params !== undefined) {
        const response = await getPageApi(params);
        ctx.commit("updateCmsPageMutation", response);
      }
    },

    async [actions.FETCH_CMS_MENU](ctx?: any, subdomain?: string) {
      if (subdomain !== undefined) {
        const response = await getMenuApi(subdomain);
        if (response !== undefined) {
          ctx.commit("updateCmsMenuMutation", response);
        }
      }
    }
  },
  mutations: {
    updateCmsBodyClassMutation(state?: any, cmsBodyClass?: any) {
      state.cmsBodyClass = cmsBodyClass;
    },
    updateCmsPageMutation(state?: any, cmsPage?: any) {
      state.cmsPage = cmsPage;
    },
    updateCmsMenuMutation(state?: any, cmsMenu?: any) {
      state.cmsMenu = cmsMenu;
    },
    updateIsCmsUsedMutation(state?: any, isCmsUsed?: boolean) {
      state.isCmsUsed = isCmsUsed;
    }
  },
  state: {
    cmsBodyClass: {} as CmsBodyClassVm,
    cmsPage: {} as CmsPageVm,
    cmsMenu: {} as CmsMenuVm,
    isCmsUsed: false
  },
  getters: {
    getCmsPage(state?: any) {
      return state.cmsPage;
    },
    getIsCmsUsed(state?: any) {
      return state.isCmsUsed;
    },
    getCmsPageTitle(state?: any) {
      if (state.cmsPage === null || state.cmsPage === undefined) {
        return null;
      }
      return state.cmsPage.title;
    }
  }
};
